// extracted by mini-css-extract-plugin
export default {"form":"add-receiver-info-form_form__R2byB","grid":"add-receiver-info-form_grid__C5kdX","field":"add-receiver-info-form_field__LLkUe","title":"add-receiver-info-form_title__wuAaL"};